// Imports for external libraries go here.
import { FC, useState } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { baseVariables } from '@marriott/mi-ui-library';
import { useEffect } from 'react';
import { useMediaQuery } from '../../../hooks';
import { ActiveMenuItem } from '../../../organisms/SecondaryNavigation/SecondaryNavigation.types';
import { useMediaQueryStore } from '../../../store';
import { DefaultSecondaryNavigationModel } from './DefaultSecondaryNavigation.types';
import DefaultSecondaryNavigationDesktop from './DefaultSecondaryNavigationDesktop/DefaultSecondaryNavigationDesktop';
import DefaultSecondaryNavigationMobile from './DefaultSecondaryNavigationMobile/DefaultSecondaryNavigationMobile';

// Use named rather than default exports.
export const DefaultSecondaryNavigation: FC<DefaultSecondaryNavigationModel> = props => {
  const { defaultSectionNavigationItems } = props;

  const { isDesktop, setIsDesktop } = useMediaQueryStore();

  const matchesDesktop = useMediaQuery(baseVariables.mediaQuery.lg);

  const [activeMenuItem, setActiveMenuItem] = useState<ActiveMenuItem>(
    props?.activeMenuItem ?? {
      menuLabel: '',
      subMenuLabel: '',
    }
  );

  useEffect(() => {
    if (matchesDesktop !== null) {
      setIsDesktop(matchesDesktop);
    }
  }, [matchesDesktop, setIsDesktop]);

  useEffect(() => {
    if (defaultSectionNavigationItems?.length) {
      const activePath = window.location.pathname;

      defaultSectionNavigationItems.some(mainMenuItem => {
        const subMenuItem = mainMenuItem?.sectionNavigationSubItems?.find(sub => sub.subMenuItemPath === activePath);

        if (subMenuItem) {
          setActiveMenuItem({
            menuLabel: mainMenuItem.menuItemLabel,
            subMenuLabel: subMenuItem.subMenuItemLabel,
          });
          return true;
        }

        if (mainMenuItem?.menuItemPath === activePath) {
          setActiveMenuItem({
            menuLabel: mainMenuItem?.menuItemLabel,
            subMenuLabel: '',
          });
          return true;
        }

        return false;
      });
    }
  }, [defaultSectionNavigationItems]);

  return (
    <>
      {isDesktop ? (
        <DefaultSecondaryNavigationDesktop {...props} activeMenuItem={activeMenuItem} />
      ) : (
        <DefaultSecondaryNavigationMobile {...props} activeMenuItem={activeMenuItem} />
      )}
    </>
  );
};
